const videoLayers = document.querySelectorAll('.wp-block-acf-video .video__layer');

videoLayers.forEach(layer => {
  layer.addEventListener('click', function() {
    const video = layer.closest('.wp-block-acf-video').querySelector('video');
    video.play();
    layer.style.display = 'none';
  });
});
